// frontend/src/site/layouts/SiteLayout.jsx
import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useSite } from '../SiteContext';

import SiteTopBar from '../pages/SiteTopBar';
import SiteFooter from '../components/SiteFooter';

import { siteRootStyle, textBaseClasses } from '../theme/siteStyles';

export default function SiteLayout() {
  const { theme, perfilSite } = useSite();

  const modelId = useMemo(() => {
    return String(perfilSite?.siteConfig?.modelId || 'corretor')
      .trim()
      .toLowerCase();
  }, [perfilSite?.siteConfig?.modelId]);

  const siteTemplate = useMemo(() => {
    return String(perfilSite?.siteTemplate || '')
      .trim()
      .toLowerCase();
  }, [perfilSite?.siteTemplate]);

  const isImobiliaria = modelId === 'imobiliaria';

  // ✅ Quando for Lovable, NÃO usa TopBar/Footer do engine antigo
  const isLovable = siteTemplate === 'lovable' || modelId === 'lovable';

  if (isLovable) {
    // ✅ Lovable já tem header/sections/footer próprios
    return (
      <div style={siteRootStyle(theme)} className={textBaseClasses()}>
        <main className="min-h-screen">
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div style={siteRootStyle(theme)} className={textBaseClasses()}>
      {/* TopBar overlay */}
      <SiteTopBar />

      {/* Se for modelo imobiliária, NÃO empurra o hero pra baixo */}
      <main className={`min-h-screen ${isImobiliaria ? 'pt-0' : 'pt-16'}`}>
        <Outlet />
      </main>

      <SiteFooter />
    </div>
  );
}
